import Vue from 'vue'
import Vuex from 'vuex'
import modUser from './modUser'
import modProduto from './modProduto'
import modLista from './modLista'
import modBackup from "./modBackup";
import uploadModule from "./upload"

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    modUser,
    modProduto,
    modLista,
    modBackup,
    upload : uploadModule
  },
});
